import type {ReactNode} from 'react'
import {Tooltip as ReactTooltip} from 'react-tooltip'
import {useDevice} from '@local/hooks'

export interface TooltipProps {
	children?: ReactNode
	className: string
	content: string
}

export const Tooltip = ({children, className, content, place}: TooltipProps) => {
	const device = useDevice()
	return (
		<span className='leading-tight tooltip-container'>
			<a data-tooltip-id='my-tooltip' data-tooltip-content={content} className='underline text-[#9083e1]'>
				{children}
			</a>
			{device === 'mobile' ? <ReactTooltip id='my-tooltip' className='tooltip-sm w-300' place='bottom' /> : <ReactTooltip id='my-tooltip' className='tooltip-lg' place={place} />}
		</span>
	)
}
